import { useEffect } from "react";
import {
  loadCargoEvents,
  unloadCargoEvents,
} from "../../../ducks/data/cargo-events";
import { useAppDispatch } from "../../../redux-store";
import { CargoModalEntityType } from "./CargoModalEntityType";

const useCargoEvents = ({
  cargoId,
  entityType,
}: {
  cargoId: string | null;
  entityType: CargoModalEntityType;
}) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (cargoId && entityType === CargoModalEntityType.CARGO) {
      dispatch(loadCargoEvents(cargoId));
    }

    return () => {
      if (cargoId && entityType === CargoModalEntityType.CARGO) {
        dispatch(unloadCargoEvents(cargoId));
      }
    };
  }, [dispatch, cargoId, entityType]);
};

export default useCargoEvents;
